
import React from 'react';
import { Helmet } from 'react-helmet';

function SEOHead({ 
  title, 
  description, 
  canonical, 
  ogImage,
  twitterImage,
  imageAlt,
  schema,
  schemas = [] 
}) {
  const siteTitle = title || 'Premium Wooden Toys & Pet Products South Africa | Hublu';
  const siteDescription = description || 'Shop premium wooden toys, Montessori toys, doll houses and quality pet products in South Africa. Beautifully designed products for children and pets. Nationwide delivery.';
  const siteCanonical = canonical;
  
  const defaultImage = 'https://hubluonline.co.za/images/1688e2632df96f630673172d438e8de1.png';
  const defaultImageAlt = 'HUBLU Logo';
  
  const finalOgImage = ogImage || defaultImage;
  const finalTwitterImage = twitterImage || defaultImage;
  const finalImageAlt = imageAlt || defaultImageAlt;

  // Combine single schema and schemas array for backward compatibility
  const allSchemas = [...(schema ? [schema] : []), ...schemas];

  return (
    <Helmet>
      <html lang="en-ZA" />
      <title>{siteTitle}</title>
      <meta name="description" content={siteDescription} />
      <link rel="canonical" href={siteCanonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:url" content={siteCanonical} />
      <meta property="og:image" content={finalOgImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:alt" content={finalImageAlt} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDescription} />
      <meta name="twitter:image" content={finalTwitterImage} />
      <meta name="twitter:image:alt" content={finalImageAlt} />

      {allSchemas.map((s, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
}

export default SEOHead;
